import { ColDef, ColGroupDef } from 'ag-grid-community';
import {
    DEFAULT_ROW_GROUP_COLUMN,
    GREY_HEADER_CLASS,
    LAST_YEAR_COLUMN_STYLE,
    MonthlyColDefGetterArguments,
    getDateColumnsForVentilation,
    isColumnFromLastYearToggle,
    dateVentilatedTablesCellRendererSelector,
    shouldHideColumnByDefault,
} from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/gridHelpers';
import {
    DEFAULT_AMOUNT_COLUMN,
    NUMBER_FILTER,
} from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/defaultColDefs';
import {
    ABSENCE_COST,
    ABSENCE_COUNT,
    ABSENCE_REASON,
} from 'routes/HumanResourcesModule/business/definitions';
import { floatFormatter } from 'ui/AgGridReact/formatters';
import { getDateColumnLabel } from 'routes/HumanResourcesModule/helpers/dataHelpers';
import { getGroupedAgentColumn } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/agentColumnHelpers';
import { getGroupedOrgChartHrColumn } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/orgChartHrColumnHelpers';
import { getMantyStatusColumn } from 'routes/HumanResourcesModule/PayState/helpers/colDefinitions';

const getAmountColumns = (
    colDefArgs: MonthlyColDefGetterArguments,
): ColGroupDef[] => {
    const { dateColumns, isMonthly, exercice, showLastYearColumns, t } =
        colDefArgs;
    const dates = getDateColumnsForVentilation(dateColumns, isMonthly);
    return dates.map((date) => {
        const isLastYearToggleColumn = isColumnFromLastYearToggle(
            date,
            isMonthly,
            exercice,
        );
        const isHidden = shouldHideColumnByDefault(
            showLastYearColumns,
            isLastYearToggleColumn,
        );
        const headerClass = isLastYearToggleColumn
            ? GREY_HEADER_CLASS
            : undefined;
        const cellRendererSelector = dateVentilatedTablesCellRendererSelector(
            isMonthly,
            exercice,
            date,
        );
        return {
            headerName: getDateColumnLabel(date, isMonthly),
            headerClass,
            children: [
                {
                    ...DEFAULT_AMOUNT_COLUMN,
                    hide: isHidden,
                    field: `${ABSENCE_COST}..${date}`,
                    headerName: t('humanResources.payState.absenceCost'),
                    headerClass,
                    aggFunc: 'sum',
                    cellRendererSelector,
                    cellRendererParams: { exercice },
                    cellStyle: isLastYearToggleColumn
                        ? LAST_YEAR_COLUMN_STYLE
                        : undefined,
                },
                {
                    ...NUMBER_FILTER,
                    hide: isHidden,
                    field: `${ABSENCE_COUNT}..${date}`,
                    headerName: t('humanResources.payState.absencesDays'),
                    headerClass,
                    valueFormatter: floatFormatter,
                    aggFunc: 'sum',
                    cellRendererSelector,
                    cellRendererParams: { exercice },
                    width: 120,
                    cellStyle: isLastYearToggleColumn
                        ? LAST_YEAR_COLUMN_STYLE
                        : undefined,
                },
            ],
        };
    });
};

export const getColDefs = (
    coldDefArgs: MonthlyColDefGetterArguments,
): ColDef[] => [
    getGroupedOrgChartHrColumn(),
    {
        ...getGroupedAgentColumn(true),
    },
    getMantyStatusColumn(),
    {
        ...DEFAULT_ROW_GROUP_COLUMN,
        width: 200,
        headerName: coldDefArgs.t('humanResources.payState.absenceType'),
        field: ABSENCE_REASON,
        enableRowGroup: true,
    },
    ...getAmountColumns(coldDefArgs),
];
